<template>
  <div>
    <div
      style="padding-left: 20px; padding-right: 30px; padding-bottom: 5px; padding-top: 10px;"
    >
      <v-layout row>
        <v-flex xs5>
          <v-layout column>
            <v-btn
              max-width="150"
              small
              rounded
              color="red"
              :disabled="selectedType.length == 0"
              @click="selectedType = []"
            >
              Clear Filters
            </v-btn>
            <v-radio-group multiple v-model="selectedType" label="Filters">
              <v-radio
                v-for="n in 3"
                :key="n"
                :label="`${types[n - 1]['display']}`"
                :value="n"
              ></v-radio>
            </v-radio-group>
            <v-btn
              style="margin-top: 10px;"
              max-width="150"
              small
              rounded
              color="blue"
              :disabled="rows.length == 0"
              @click="addAllRows()"
            >
              Add All Rows
            </v-btn>
          </v-layout>
        </v-flex>
        <v-divider />
        <v-flex xs5 style="padding-right: 30px;">
          <v-layout column style="margin-left: 1px;">
            <div>
              <v-checkbox
                style="padding: 10px; margin: 0px;"
                v-model="reverse"
                label="Reverse"
                dense
              >
              </v-checkbox>
            </div>
            <v-flex xs4>
              <v-select
                dense
                outlined
                v-model="selectedCounty"
                :items="county_names"
                :label="clLabel"
              >
              </v-select>
            </v-flex>
            <v-flex xs1 />
            <v-flex xs4>
              <v-select
                :v-if="selectedCounty != null"
                dense
                outlined
                v-model="selectedCity"
                :items="cityCandidates"
                label="Select City"
              >
              </v-select>
            </v-flex>
            <v-btn
              max-width="200"
              small
              rounded
              color="green"
              :disabled="selectedRows.length == 0"
              @click="addSelectedRows"
            >
              Add Selected Rows
            </v-btn>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>
    <v-card style="height: 70%; overflow-y: scroll;">
      <server-table-component
        style="width: 100%;"
        :rowProp="rows"
        schema="sch_sales_pipeline_1"
        :editable="false"
        :enableRowClick="clickEnable"
        @clickedRows="clickedRows"
      ></server-table-component>
    </v-card>
  </div>
</template>

<script>
import axiosInstances from "@/../../coreui/server/axiosInstances";
import { sync } from "vuex-pathify";
export default {
  components: {},
  data: () => ({
    table: "crm_prospect",
    tableserver: axiosInstances.apiServer,
    url: "",
    pipe: [],
    rows: [],
    headers: [],
    counties: {},
    reverse: false,
    county_names: [],
    city_names: [],
    cityCandidates: [],
    selectedRows: [],
    selectedCounty: null,
    selectedCity: null,
    clLabel: "",
    clickEnable: true,
    multipleFilters: false,
    types: [
      { display: "Cultivation", id: "cultivation" },
      { display: "Microbusiness", id: "micro" },
      { display: "Opened at least one email", id: "opened" },
    ],
    selectedType: [],
    caCounties: [
      "DEL NORTE",
      "SISKIYOU",
      "MODOC",
      "HUMBOLDT",
      "TRINITY",
      "SHASTA",
      "LASSEN",
      "TEHAMA",
      "MENDOCINO",
      "GLENN",
      "BUTTE",
      "PLUMAS",
      "SIERRA",
      "NEVADA",
      "YUBA",
      "COLUSA",
      "LAKE",
      "PLACER",
      "SUTTER",
      "YOLO",
      "NAPA",
      "SONOMA",
      "EL DORADO",
      "AMADOR",
      "SOLANO",
      "SACRAMENTO",
      "MARIN",
      "CONTRA COSTA",
      "SAN JOAQIN",
      "CALAVERAS",
      "TOULUMNE",
      "MONO",
      "SAN FRANCISCO",
      "ALAMEDA",
      "STANISLAUS",
      "SAN MATEO",
      "MARIPOSA",
      "SANTA CLARA",
      "MERCED",
      "MADERA",
      "SANTA CRUZ",
      "SAN BENITO",
      "FRESNO",
      "INYO",
      "MONTEREY",
      "KINGS",
      "TULARE",
      "SAN LUIS OBISPO",
      "KERN",
      "SANTA BARBARA",
      "VENTURA",
      "SAN BERNADINO",
      "LOS ANGELES",
      "ORANGE",
      "RIVERSIDE",
      "SAN DIEGO",
      "IMPERIAL",
    ],
  }),
  computed: {
    tableName: sync("tableName"),
    usePagination: sync("tableUseSSPagination"),
  },
  watch: {
    reverse: {
      immediate: true,
      handler(val) {
        if (val) {
          this.county_names = [...this.caCounties];
          this.county_names.reverse();
          this.clLabel = "Select County (Listed South to North)";
        } else {
          this.county_names = this.caCounties;
          this.clLabel = "Select County (Listed North to South)";
        }
      },
    },
    selectedCounty(val) {
      console.log(this.counties);
      let cities = this.counties.filter((i) => Object.keys(i) == val);
      let temp = [];
      this.cityCandidates = cities[0][val].forEach((i) => {
        if (typeof i === "string") temp.push(i.toUpperCase());
        if (typeof i == "object")
          i.forEach((j) => {
            temp.push(j.toUpperCase());
          });
      });
      this.cityCandidates = temp;
      this.selectedCity = null;
      this.buildTable();
    },
    selectedCity(val) {
      this.rows = []
      this.buildTable();
    },
    selectedType: {
      deep: true,
      handler(val) {
        console.log(this.selectedType)
        this.buildTable();
      },
    },
  },
  methods: {
    buildPipe() {
      this.pipe = [];
      let preFilter = [
        { $match: { $expr: { $ne: ["$IsUsed", "no"] } } },
        { $match: { phone: { $ne: null } } },
        { $match: { county: this.selectedCounty } },
        { $match: { city: this.selectedCity } },
      ];
      this.pipe = this.pipe.concat(preFilter);
      console.log(this.selectedType);
      if (this.selectedType.includes(1))
        this.pipe = this.pipe.concat([
          { $match: { $expr: { $eq: ["$IsCultivation", "yes"] } } },
        ]);
      if (this.selectedType.includes(2))
        this.pipe = this.pipe.concat([
          { $match: { $expr: { $eq: ["$IsMicro", "yes"] } } },
        ]);
      if (this.selectedType.includes(3))
        this.pipe = this.pipe.concat([
          { $match: { $expr: { $gt: [{ $toInt: "$open" }, 0] } } },
        ]);
    },
    buildHeaders() {
      this.headers = [];
      this.headers.push({
        text: "Email",
        value: "email",
        show: true,
        format: "type:self;filter:string",
      });
    },
    async findCounties() {
      let pipe = [
        { $match: { $expr: { $ne: ["$IsUsed", "no"] } } },
        { $match: { phone: { $ne: null } } },
        { $match: { city: { $ne: "" } } },
        { $project: { city: 1, county: 1 } },
        { $unwind: "$county" },
        { $project: { _county: { $toUpper: "$county" }, city: 1 } },
        { $group: { _id: "$_county", _cities: { $addToSet: "$city" } } },
      ];
      const resp = await this.tableserver.post(this.url, pipe);
      let self = this;
      this.county_names = [];
      this.counties = resp.data.map((i) => {
        self.county_names.push(i["_id"]);
        let k = {};
        k[i["_id"]] = i["_cities"];
        return k;
      });
      // for CA
      this.county_names = this.caCounties;
    },
    async buildTable() {
      if (this.selectedCity == null) {
        this.rows = []
        return;
      }
      this.resetRowSelection()
      this.buildPipe();
      const resp = await this.tableserver.post(this.url, this.pipe);
      if (resp.data != null) this.rows = resp.data;
    },
    clickedRows(rows) {
      this.selectedRows = rows
    },
    async addTheseRows(rows) {
      let newLead = 0
      let existingLead = 0
      let res = await axiosInstances.loginServer.get('/dt/v1/sch_crm_sales_pipeline')
      let sch = res.data
      this.$toasted.clear()
      this.$toasted.show('Adding items to pipeline', {type: 'info'})
      for (var i=0; i< rows.length; i++) {
        res = await axiosInstances.apiServer.get('/dt/v1/crm_sales_pipeline?prospect_id=' + this.rows[i]._id)
        if (res.data == null ) {
          newLead++
          let newItem = {}
          sch.forEach((x) => {
            if (x['key'] == 'prospect_id')  {
              newItem['prospect_id'] = this.rows[i]['_id']
            } else {
              newItem[x['key']] = this.rows[i][x['key']]
            }
          })
          newItem['qual'] = 'Pending'
          console.log(newItem)
          await axiosInstances.apiServer.post('/dt/v1/crm_sales_pipeline', newItem)
        } else {
          existingLead++
        }
      }
      this.$toasted.clear()
      this.$toasted.show(`Added ${newLead} new items ` + existingLead > 0 ? `and ignored ${existingLead} existing items` : '', {type: 'success', duration: 300 * 1000})
      console.log(`new lead = ${newLead}, existing lead = ${existingLead}`)
    },
    async addSelectedRows () {
      let rows = this.rows.filter((x) => {return this.selectedRows.includes(x['_id'])})
      await this.addTheseRows(rows)
    },
    async addAllRows () {
      await this.addTheseRows(this.rows)
    },
    resetRowSelection () {
      this.clickEnable = false
      this.selectedRows = []
      this.$nextTick(() => {this.clickEnable = true})
    }
  },
  async mounted() {
    this.url = "/misc/dbops?c=" + this.table + "&op=pipe";
    await this.findCounties();
  },
  beforeDestroy() {},
};
</script>
<style>
.upload-insert-button {
  position: relative;
  overflow: hidden;
  display: inline-block;

  /* Fancy button style 😎 */
  border: 2px solid;
  border-radius: 5px;
  padding: 8px 12px;
  cursor: pointer;
}

.upload-overwrite {
  position: relative;
  overflow: hidden;
  display: inline-block;
  padding: 0px;
  margin: 0px;
  cursor: pointer;
}
</style>
